export type MxButtonHiddenFn = () => boolean;
export type MxButtonTooltipFn = () => string;
export type MxButtonIconFn = () => string;
export type MxButtonLabelFn = () => string;

export type MxButtonClickHandlerFn = () => void;
export type MxButtonDisableFn = () => boolean;

export class MxButtonModel {

    public permission?: string = 'all';
    public hidden?: MxButtonHiddenFn | boolean = false;
    public label?: MxButtonLabelFn | string;
    public name?: string;
    public className?: string;
    public color?: string;
    public icon?: MxButtonIconFn | string;
    public tooltip?: MxButtonTooltipFn | string;
    public disabled?: MxButtonDisableFn | boolean = false;
    public clickHandler?: MxButtonClickHandlerFn;
}

export class MxButtonsConfig {
    private _map: Map<string, MxButtonModel>;

    constructor(entries?: ReadonlyArray<[string, MxButtonModel]>) {
        this._map = new Map<string, MxButtonModel>(entries);
    }

    get = (key: string) => this._map.get(key);
    set = (key: string, value: MxButtonModel) => this._map.set(key, value);
    getArray = () => Array.from(this._map.values());
    forEach = (callback: (value: MxButtonModel, key: string, map: Map<string, MxButtonModel>) => void, thisArg?: any) =>
        this._map.forEach(callback, thisArg)
}
